'use strict';

const navigation = {
	init() {
		this.toggleMobileMenu();
		this.toggleMobileSubmenu();
		this.toggleSearchMenu();
	},

	toggleMobileMenu: () => {
		const root = document.documentElement;
		const navbar = document.querySelector('.rltm-navbar');
		const navbarMobile = document.querySelector('.rltm-navbar-mobile');
		const toggleMobileMenuBtn = document.querySelectorAll(
			'.rltm-navbar-btn-more'
		);
		const closeMobileMenuBtn = navbarMobile.querySelector(
			'.rltm-navbar-mobile-close-btn'
		);
		const backdrop = document.querySelector('.rltm-navbar-mobile-backdrop');

		const closeMobileMenu = () => {
			navbarMobile.classList.remove('show');
			root.classList.remove('rltm-hide-scrollbar');
		};

		const handleKeyDown = (event) => {
			if (event.key === 'Escape') {
				closeMobileMenu();
			}
		};

		if (
			navbar &&
			navbarMobile &&
			toggleMobileMenuBtn &&
			closeMobileMenuBtn &&
			backdrop
		) {
			toggleMobileMenuBtn.forEach((toggle) => {
				toggle.addEventListener('click', (e) => {
					e.preventDefault();
					navbarMobile.classList.toggle('show');
					root.classList.toggle('rltm-hide-scrollbar');
				});
			});

			closeMobileMenuBtn.addEventListener('click', (e) => {
				e.preventDefault();
				closeMobileMenu();
			});

			backdrop.addEventListener('click', () => {
				closeMobileMenu();
			});

			document.addEventListener('keydown', handleKeyDown);
		}
	},

	/**
	 * This function adds toggle buttons to mobile submenu items and enables opening and
	 * closing of submenus upon clicking. When a user clicks on a menu item with a submenu,
	 * which is represented as a link, a toggle button in the form of an arrow is appended
	 * to it. The function then monitors click events on these links.
	 * If the click target is not the submenu toggle button itself, the function toggles
	 * the submenu's active state and prevents the default action of the link.
	 */
	toggleMobileSubmenu: () => {
		const submenuItems = document.querySelectorAll(
			'.rltm-navbar-mobile-middle .menu-item-has-children > a'
		);

		submenuItems.forEach((item) => {
			item.insertAdjacentHTML(
				'beforeend',
				'<span class="rltm-submenu-toggle"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L11.2929 14.2929C11.6262 14.6262 11.7929 14.7929 12 14.7929C12.2071 14.7929 12.3738 14.6262 12.7071 14.2929L18 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
			);
		});

		submenuItems.forEach((toggle) => {
			toggle.addEventListener('click', (event) => {
				// If click target is not submenu link then this is a submenu toggle.
				if (!event.target.querySelector('.rltm-submenu-toggle')) {
					event.target
						.closest('.menu-item-has-children')
						.classList.toggle('active');
					event.preventDefault();
				}
			});
		});
	},

	toggleSearchMenu: () => {
		const navbar = document.querySelector('.rltm-navbar');
		const navbarSearchMenu = document.querySelector('.rltm-navbar-search');
		const searchInput =
			navbarSearchMenu.querySelector('.rltm-search-input');
		const toggleSearchMenuBtn = document.querySelectorAll(
			'.rltm-navbar-btn-search'
		);
		const closeSearchMenuBtn = navbarSearchMenu.querySelector(
			'.rltm-navbar-search-close-btn'
		);
		const backdrop = document.querySelector('.rltm-navbar-search-backdrop');

		const closeSearchMenu = () => {
			navbarSearchMenu.classList.remove('show');
		};

		const handleKeyDown = (event) => {
			if (event.key === 'Escape') {
				closeSearchMenu();
			}
		};

		if (
			navbar &&
			navbarSearchMenu &&
			toggleSearchMenuBtn &&
			closeSearchMenuBtn &&
			backdrop &&
			searchInput
		) {
			toggleSearchMenuBtn.forEach((toggle) => {
				toggle.addEventListener('click', (e) => {
					e.preventDefault();
					navbarSearchMenu.classList.toggle('show');
					if (navbarSearchMenu.classList.contains('show')) {
						setTimeout(() => {
							searchInput.focus();
						}, 450);
					}
				});
			});

			closeSearchMenuBtn.addEventListener('click', (e) => {
				e.preventDefault();
				closeSearchMenu();
			});

			backdrop.addEventListener('click', () => {
				closeSearchMenu();
			});

			document.addEventListener('keydown', handleKeyDown);
		}
	},
};

navigation.init();
